import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD, SuggestionSearch, ResponseDataArray } from '../schemas'

export const getList = (data: Search): Promise<ResponseDataList> => {
    return request({
        url: '/scenic-areas/search',
        method: 'post',
        data,
    })
}

export const doAdd = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-areas',
        method: 'post',
        data,
    })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-areas',
        method: 'put',
        data,
    })
}

export const doDelete = (data: CURD): Promise<ResponseData> => {
    return request({
        url: `/scenic-areas/${String(data.id)}`,
        method: 'delete',
    })
}

export const getDetail = (id: string): Promise<ResponseData> => {
    return request({
        url: `/scenic-areas/${id}`,
        method: 'get',
    })
}

export const getSuggestions = (data: SuggestionSearch): Promise<ResponseDataArray> => {
    return request({
        url: '/scenic-areas/suggestions',
        method: 'post',
        data
    })
}

